import React, { useEffect, useRef, useState } from "react";
import "../styles/Indicadores.css";
import { AppWindow, Pin, Hammer, Building2 } from "lucide-react"; // ícones

const Indicadores = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  const indicadores = [
    { icon: <AppWindow size={40} color="#29306a" />, valor: 2000, prefixo: "+", texto: "Acessos" },
    { icon: <Pin size={40} color="#29306a" />, valor: 180, prefixo: "+", texto: "Cidades mapeadas" },
    { icon: <Hammer size={40} color="#29306a" />, valor: 50, prefixo: "+", texto: "Construtoras" },
    { icon: <Building2 size={40} color="#29306a" />, valor: 350, prefixo: "+", texto: "Empreendimentos" },
  ];

  // Animação de contagem
  const [contagem, setContagem] = useState(indicadores.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (visible) {
      indicadores.forEach((item, i) => {
        let start = 0;
        const end = item.valor;
        const duration = 2000;
        const increment = end / (duration / 20);

        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            start = end;
            clearInterval(timer);
          }
          setContagem((prev) => {
            const novo = [...prev];
            novo[i] = parseFloat(start.toFixed(1));
            return novo;
          });
        }, 20);
      });
    }
  }, [visible]);

  return (
    <section className="indicadores" ref={ref}>
      {indicadores.map((item, index) => (
        <div key={index} className="indicador-card">
          <div className="icon">{item.icon}</div>
          <h3>
            <span className="prefixo">{item.prefixo}</span>
            {contagem[index]}
          </h3>
          <p>{item.texto}</p>
        </div>
      ))}
    </section>
  );
};

export default Indicadores;
